var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c("PeriodFilter", {
            on: { change: _vm.handleFilterChange },
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center py-8" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mb-2",
                  attrs: { type: "border", disabled: true },
                },
                [
                  _c("span", { staticClass: "animate-spin" }, [
                    _vm._v("Carregando..."),
                  ]),
                ]
              ),
            ],
            1
          )
        : [
            _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-6",
              },
              [
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Total de Alunos",
                    value: _vm.dashboardData.total_students,
                    description: "Alunos cadastrados",
                    type: "primary",
                    icon: "UsersIcon",
                    "icon-color": "success",
                    "value-size": "large",
                    formatter: _vm.formatNumber,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Alunos no Período",
                    value: _vm.dashboardData.students_in_period,
                    description: "Cadastrados no período selecionado",
                    type: "info",
                    icon: "CalendarIcon",
                    "value-size": "small",
                    formatter: _vm.formatNumber,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Alunos Este Mês",
                    value: _vm.dashboardData.students_this_month,
                    description: "Cadastrados este mês",
                    type: "success",
                    icon: "TrendingUpIcon",
                    "value-size": "small",
                    formatter: _vm.formatNumber,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Taxa de Crescimento",
                    value: _vm.dashboardData.growth_rate,
                    description: "Comparado ao mês anterior",
                    type: "warning",
                    icon: "TrendingUpIcon",
                    "value-size": "small",
                    formatter: _vm.formatGrowthRate,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Alunos Ativos",
                    value: _vm.dashboardData.active_students,
                    description: "Com aulas agendadas",
                    type: "success",
                    icon: "CheckCircleIcon",
                    "value-size": "large",
                    formatter: _vm.formatNumber,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Alunos Inativos",
                    value: _vm.dashboardData.inactive_students,
                    description: "Sem aulas agendadas",
                    type: "warning",
                    icon: "UserXIcon",
                    "value-size": "large",
                    formatter: _vm.formatNumber,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" },
              [
                _c(
                  "vx-card",
                  [
                    _c("template", { slot: "no-body" }, [
                      _c(
                        "div",
                        { staticClass: "p-6" },
                        [
                          _c(
                            "h3",
                            { staticClass: "mb-4 font-semibold text-lg" },
                            [_vm._v(" Evolução de Cadastros ")]
                          ),
                          _vm.dashboardData.evolution_data &&
                          _vm.dashboardData.evolution_data.labels &&
                          _vm.dashboardData.evolution_data.labels.length > 0
                            ? _c("vue-apex-charts", {
                                attrs: {
                                  type: "line",
                                  height: "350",
                                  options: _vm.evolutionChartOptions,
                                  series: _vm.evolutionSeries,
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center h-64 text-gray-500",
                                },
                                [_vm._v(" Nenhum dado disponível ")]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "vx-card",
                  [
                    _c("template", { slot: "no-body" }, [
                      _c(
                        "div",
                        { staticClass: "p-6" },
                        [
                          _c(
                            "h3",
                            { staticClass: "mb-4 font-semibold text-lg" },
                            [_vm._v(" Distribuição por Modalidade ")]
                          ),
                          _vm.modalitySeries &&
                          _vm.modalitySeries.length > 0 &&
                          _vm.modalityLabels.length > 0
                            ? _c("vue-apex-charts", {
                                attrs: {
                                  type: "donut",
                                  height: "350",
                                  options: _vm.modalityChartOptions,
                                  series: _vm.modalitySeries,
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center h-64 text-gray-500",
                                },
                                [_vm._v(" Nenhum dado disponível ")]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }